import { render, staticRenderFns } from "./Nav-gob.vue?vue&type=template&id=159ceaaf&scoped=true"
var script = {}
import style0 from "./Nav-gob.vue?vue&type=style&index=0&id=159ceaaf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "159ceaaf",
  null
  
)

export default component.exports